<script setup lang="ts">
const props = defineProps<{
  title: string;
  subtitle?: string;
  tag?: string | null;
  songLengthSeconds: number;
  forceBackgroundIndex?: number | null;
}>();

const artwork = ref<HTMLDivElement | null>(null);

const { height, width } = useElementSize(artwork);

const showTag = computed(() => (width.value || 0) > 150);

const fontSize = computed(() => {
  return height.value * 0.2 + "px"; /* 0.15 */
});
const subtitleFontSize = computed(() => {
  return height.value * 0.075 + "px"; /*0.075*/
});

const padding = computed(() => {
  return height.value * 0.1 + "px";
});

const backgroundImgSrc = computed(() =>
  determineGradient(props.title, props.forceBackgroundIndex),
);

const durationPretty = computed(
  () =>
    (props.songLengthSeconds &&
      formatTime(Math.round(props.songLengthSeconds))) ||
    "",
);
</script>

<template>
  <div
    ref="artwork"
    class="artwork"
  >
    <Image
      :src="backgroundImgSrc"
      alt="background"
      class="bg-image"
    />
    <div
      v-if="showTag && tag"
      class="artwork-tag"
    >
      {{ tag }}
    </div>
    <div class="artwork-text">
      <div class="title">
        {{ title }}
      </div>
      <!-- <div
        v-if="subtitle"
        class="subtitle"
      >
        {{ subtitle }}
      </div> -->
      <div
        v-if="durationPretty && showTag"
        class="duration"
      >
        {{ durationPretty }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.artwork {
  @apply relative flex aspect-video h-full w-full items-center justify-center overflow-hidden rounded-lg bg-black/75;
  padding: v-bind(padding);
}
.bg-image {
  @apply absolute left-0 top-0 h-full w-full;
  &:deep(img) {
    @apply pointer-events-none h-full w-full object-cover;
  }
}
.artwork-text {
  @apply z-10;
}
.title {
  @apply text-center text-white;
  font-size: v-bind(fontSize);

  font-family: "scale-variable", sans-serif;
  font-variation-settings:
    "wdth" 100,
    "wght" 400;
}
.artwork-tag {
  @apply absolute left-2 top-2 rounded bg-white px-1 text-xs uppercase text-black;
}
.subtitle {
  @apply text-center font-display italic text-white/50;
  font-size: v-bind(subtitleFontSize);
}
.duration {
  @apply absolute bottom-2 left-2 rounded bg-black px-1 py-0 text-sm text-white;
}
</style>
